import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Button, SegmentedControl, useMantineTheme, Text, Paper, Select, Loader, ActionIcon } from '@mantine/core';
import { IconChevronRight, IconX, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { utils, BE_API_THREE } from "../../utils/globalVariables";
import { getPropInSubLevelRole } from "../../utils/globalFunctions";

import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import PickerDate from "../../components/general/PickerDate";
import TeknisiSelectorDrawer from "../../components/utilities/TeknisiSelectorDrawer";

const ProjectNotaFilterBayar = ({
  stateShow,
  fnShow,
  stateDefaultFilter,
  stateFilter,
  fnFilter
}) => {

  const mountedRef = React.useRef(true);
  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetDataBarangCategory: 'projectNotaFilter-2',
  })

  const [data, setData] = React.useState({
    dataBarangCategory: [],
    dataBarangCategoryLoadingInit: false,

    teknisiSelectorModal: false,

    barangCategory: stateFilter.barangCategory,

    tanggalNotaDari: stateFilter.tanggalNotaDari,
    tanggalNotaSampai: stateFilter.tanggalNotaSampai,

    tanggalAmbilDari: stateFilter.tanggalAmbilDari,
    tanggalAmbilSampai: stateFilter.tanggalAmbilSampai,

    tanggalBayarDari: stateFilter.tanggalBayarDari,
    tanggalBayarSampai: stateFilter.tanggalBayarSampai,

    tanggalDeadlinePengecekanDari: stateFilter.tanggalDeadlinePengecekanDari,
    tanggalDeadlinePengecekanSampai: stateFilter.tanggalDeadlinePengecekanSampai,
    tanggalDeadlineSelesaiDari: stateFilter.tanggalDeadlineSelesaiDari,
    tanggalDeadlineSelesaiSampai: stateFilter.tanggalDeadlineSelesaiSampai,
    deadlinePengecekan: stateFilter.deadlinePengecekan,
    deadlineSelesai: stateFilter.deadlineSelesai,

    deadlinePengecekanSudah: stateFilter.deadlinePengecekanSudah,
    deadlineSelesaiSudah: stateFilter.deadlineSelesaiSudah,

    teknisi: stateFilter.teknisi,

    isSudahRating: stateFilter.isSudahRating,
    isLunas: stateFilter.isLunas,
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  React.useEffect(() => {
    setData(d => ({ ...d, dataBarangCategoryLoadingInit: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('flag_all', utils.flagAll);

    axios({
      method: 'post',
      url: BE_API_THREE + '/get_barang_category',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataBarangCategoryLoadingInit: false }));

      if (response.data.flag_status === 'isset') {
        setData(d => ({
          ...d,
          dataBarangCategory: response.data.data,
        }));
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, dataBarangCategoryLoadingInit: false }));

      notifications.show({
        id: notificationId.current.errorGetDataBarangCategory,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }, [handleSetLoginContext, loginContext.syswebapp])

  const handleFilter = () => {
    fnFilter({
      barangCategory: data.barangCategory,

      tanggalNotaDari: data.tanggalNotaDari,
      tanggalNotaSampai: data.tanggalNotaSampai,

      tanggalAmbilDari: data.tanggalAmbilDari,
      tanggalAmbilSampai: data.tanggalAmbilSampai,

      tanggalBayarDari: data.tanggalBayarDari,
      tanggalBayarSampai: data.tanggalBayarSampai,

      tanggalDeadlinePengecekanDari: data.tanggalDeadlinePengecekanDari,
      tanggalDeadlinePengecekanSampai: data.tanggalDeadlinePengecekanSampai,
      tanggalDeadlineSelesaiDari: data.tanggalDeadlineSelesaiDari,
      tanggalDeadlineSelesaiSampai: data.tanggalDeadlineSelesaiSampai,
      deadlinePengecekan: data.deadlinePengecekan,
      deadlineSelesai: data.deadlineSelesai,

      deadlinePengecekanSudah: data.deadlinePengecekanSudah,
      deadlineSelesaiSudah: data.deadlineSelesaiSudah,

      teknisi: data.teknisi,

      isSudahRating: data.isSudahRating,
      isLunas: data.isLunas,
    })
  }

  const handleReset = () => {
    setData(d => ({
      ...d,
      barangCategory: stateDefaultFilter.barangCategory,

      tanggalNotaDari: stateDefaultFilter.tanggalNotaDari,
      tanggalNotaSampai: stateDefaultFilter.tanggalNotaSampai,

      tanggalAmbilDari: stateDefaultFilter.tanggalAmbilDari,
      tanggalAmbilSampai: stateDefaultFilter.tanggalAmbilSampai,

      tanggalBayarDari: stateDefaultFilter.tanggalBayarDari,
      tanggalBayarSampai: stateDefaultFilter.tanggalBayarSampai,

      tanggalDeadlinePengecekanDari: stateDefaultFilter.tanggalDeadlinePengecekanDari,
      tanggalDeadlinePengecekanSampai: stateDefaultFilter.tanggalDeadlinePengecekanSampai,
      tanggalDeadlineSelesaiDari: stateDefaultFilter.tanggalDeadlineSelesaiDari,
      tanggalDeadlineSelesaiSampai: stateDefaultFilter.tanggalDeadlineSelesaiSampai,
      deadlinePengecekan: stateDefaultFilter.deadlinePengecekan,
      deadlineSelesai: stateDefaultFilter.deadlineSelesai,

      deadlinePengecekanSudah: stateDefaultFilter.deadlinePengecekanSudah,
      deadlineSelesaiSudah: stateDefaultFilter.deadlineSelesaiSudah,

      teknisi: stateDefaultFilter.teknisi,

      isSudahRating: stateDefaultFilter.isSudahRating,
      isLunas: stateDefaultFilter.isLunas,
    }))
  }

  return (
    <React.Fragment>
      <Drawer
        opened={stateShow}
        onClose={fnShow}
        withCloseButton={false}
        position="left"
        closeOnClickOutside={true}

        title={
          <Group noWrap spacing='xs'>
            <ActionIcon
              size='lg'
              variant="light"
              radius='xl'
              color="blue"
              onClick={fnShow}
            >
              <IconArrowLeft size='1.25rem' stroke={1.5} />
            </ActionIcon>

            <Text>Filter Nota</Text>
          </Group>
        }
        size='md'

        styles={() => ({
          title: {
            fontWeight: 'bold',
            textTransform: 'uppercase',
          }
        })}
      >
        <Box py='md' sx={{ minHeight: '500px' }}>
          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel={
                <Group>
                  <Text>Kategori Barang</Text>
                  {data.dataBarangCategoryLoadingInit && <Loader size="xs" />}
                </Group>
              }
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <Select
                value={data.barangCategory}
                onChange={(val) => setData(d => ({ ...d, barangCategory: val }))}
                data={[
                  { value: utils.flagAll, label: 'Semua' },
                  ...data.dataBarangCategory.map(key => ({ value: key.barang_category_id, label: key.barang_category_name }))
                ]}

                styles={(tema) => ({
                  input: {
                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                  }
                })}
              />
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel='Tanggal Masuk'
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <Group spacing='xs'>
                <PickerDate
                  stateMinDate={null}
                  stateDate={data.tanggalNotaDari}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalNotaDari: val
                  }))}

                  stateSX={{
                    flex: 1,
                  }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalNotaDari === null ? 'Semua' : 'Tanggal Masuk'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />

                <Text size='sm'>s/d</Text>

                <PickerDate
                  stateMinDate={data.tanggalNotaDari}
                  stateDate={data.tanggalNotaSampai}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalNotaSampai: val
                  }))}

                  stateSX={{
                    flex: 1,
                  }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalNotaSampai === null ? 'Semua' : 'Tanggal Masuk'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />
              </Group>
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel='Tanggal Deadline Pengecekan'
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <Group spacing='xs'>
                <PickerDate
                  stateMinDate={null}
                  stateDate={data.tanggalDeadlinePengecekanDari}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalDeadlinePengecekanDari: val
                  }))}

                  stateSX={{
                    flex: 1,
                  }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalDeadlinePengecekanDari === null ? 'Semua' : 'Tanggal Deadline Pengecekan'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />

                <Text size='sm'>s/d</Text>

                <PickerDate
                  stateMinDate={data.tanggalDeadlinePengecekanDari}
                  stateDate={data.tanggalDeadlinePengecekanSampai}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalDeadlinePengecekanSampai: val
                  }))}

                  stateSX={{
                    flex: 1,
                  }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalDeadlinePengecekanSampai === null ? 'Semua' : 'Tanggal Deadline Pengecekan'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />
              </Group>
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel='Tanggal Deadline Selesai'
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <Group spacing='xs'>
                <PickerDate
                  stateMinDate={null}
                  stateDate={data.tanggalDeadlineSelesaiDari}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalDeadlineSelesaiDari: val
                  }))}

                  stateSX={{
                    flex: 1,
                  }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalDeadlineSelesaiDari === null ? 'Semua' : 'Tanggal Deadline Selesai'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />

                <Text size='sm'>s/d</Text>

                <PickerDate
                  stateMinDate={data.tanggalDeadlineSelesaiDari}
                  stateDate={data.tanggalDeadlineSelesaiSampai}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalDeadlineSelesaiSampai: val
                  }))}

                  stateSX={{
                    flex: 1,
                  }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalDeadlineSelesaiSampai === null ? 'Semua' : 'Tanggal Deadline Selesai'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />
              </Group>
            </InputWrapperCustom>
          </Box>

          {/* batas ambil */}
          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel='Tanggal Ambil'
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <Group spacing='xs'>
                <PickerDate
                  stateMinDate={null}
                  stateDate={data.tanggalAmbilDari}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalAmbilDari: val
                  }))}

                  stateSX={{ flex: 1 }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalAmbilDari === null ? 'Semua' : 'Tanggal Ambil Dari'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />

                <Text size='sm'>s/d</Text>

                <PickerDate
                  stateMinDate={data.tanggalAmbilDari}
                  stateDate={data.tanggalAmbilSampai}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalAmbilSampai: val
                  }))}

                  stateSX={{ flex: 1 }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalAmbilSampai === null ? 'Semua' : 'Tanggal Ambil Selesai'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />
              </Group>
            </InputWrapperCustom>
          </Box>
          {/* batas ambil */}

          {/* batas bayar */}
          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel='Tanggal Bayar'
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <Group spacing='xs'>
                <PickerDate
                  stateMinDate={null}
                  stateDate={data.tanggalBayarDari}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalBayarDari: val
                  }))}

                  stateSX={{ flex: 1 }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalBayarDari === null ? 'Semua' : 'Tanggal Bayar Dari'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />

                <Text size='sm'>s/d</Text>

                <PickerDate
                  stateMinDate={data.tanggalBayarDari}
                  stateDate={data.tanggalBayarSampai}

                  fnSetDate={(val) => setData(d => ({
                    ...d,
                    tanggalBayarSampai: val
                  }))}

                  stateSX={{ flex: 1 }}

                  stateFormat="DD MMM YYYY"
                  stateClearable={true}
                  stateLabel=''
                  statePlaceHolder={data.tanggalBayarSampai === null ? 'Semua' : 'Tanggal Bayar Selesai'}
                  stateWithAsterisk={false}
                  stateDescription=''
                  stateError=''
                />
              </Group>
            </InputWrapperCustom>
          </Box>
          {/* batas bayar */}

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel="Deadline Pengecekan"
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <SegmentedControl
                fullWidth
                mb='.25rem'
                value={data.deadlinePengecekanSudah}
                onChange={(val) => setData(d => ({ ...d, deadlinePengecekanSudah: val }))}
                data={[
                  { label: 'Semua', value: utils.flagAll },
                  { label: 'Sudah Cek', value: 'sudah' },
                  { label: 'Belum Cek', value: 'belum' },
                ]}
              />

              <SegmentedControl
                fullWidth
                value={data.deadlinePengecekan}
                onChange={(val) => setData(d => ({ ...d, deadlinePengecekan: val }))}
                data={[
                  { label: 'Semua', value: utils.flagAll },
                  { label: 'Terlewat', value: 'terlewat' },
                  { label: 'Berjalan', value: 'belum_terlewat' },
                  { label: 'Terakhir', value: 'terakhir' },
                ]}
              />
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel="Deadline Selesai"
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <SegmentedControl
                fullWidth
                mb='.25rem'
                value={data.deadlineSelesaiSudah}
                onChange={(val) => setData(d => ({ ...d, deadlineSelesaiSudah: val }))}
                data={[
                  { label: 'Semua', value: utils.flagAll },
                  { label: 'Selesai', value: 'sudah' },
                  { label: 'Belum', value: 'belum' },
                ]}
              />

              <SegmentedControl
                fullWidth
                value={data.deadlineSelesai}
                onChange={(val) => setData(d => ({ ...d, deadlineSelesai: val }))}
                data={[
                  { label: 'Semua', value: utils.flagAll },
                  { label: 'Terlewat', value: 'terlewat' },
                  { label: 'Berjalan', value: 'belum_terlewat' },
                  { label: 'Terakhir', value: 'terakhir' },
                ]}
              />
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel={<Text>Teknisi</Text>}
              stateWithAsterisk={false}
            >
              <Paper
                sx={(tema) => ({
                  backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                  cursor: 'pointer',
                })}

                onClick={() => {
                  setData(d => ({
                    ...d,
                    teknisiSelectorModal: true
                  }));
                }}
              >
                {!data.teknisi.id &&
                  <Group
                    position="apart"
                    noWrap
                    p="xs"
                  >
                    <Text size='sm'>Semua Teknisi</Text>
                    <IconChevronRight size="1rem" />
                  </Group>
                }

                {data.teknisi.id &&
                  <Group
                    position="apart"
                    noWrap
                    p="xs"
                  >
                    <Group noWrap>
                      <Text size='sm'>
                        <Text>
                          {data.teknisi.name}
                        </Text>

                        <Text size='xs'>
                          {getPropInSubLevelRole(data.teknisi.subLevel, 'caption', '-')}
                        </Text>
                      </Text>
                    </Group>

                    <ActionIconComponent
                      stateVariant='light'
                      stateRadius='xl'
                      stateTitle='Hapus'
                      stateSize='lg'
                      fnOnClick={(e) => {
                        e.stopPropagation();
                        setData(d => ({ ...d, teknisi: stateDefaultFilter.teknisi }))
                      }}

                      StateIcon={IconX}
                      stateIconSize='1.125rem'
                      stateIconStrokeWidth={1.25}
                      stateIconStyle={{
                        color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                      }}
                    />
                  </Group>
                }
              </Paper>
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel="Rating"
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <SegmentedControl
                fullWidth
                value={data.isSudahRating}
                onChange={(val) => setData(d => ({ ...d, isSudahRating: val }))}
                data={[
                  { label: 'Semua', value: utils.flagAll },
                  { label: 'Sudah', value: 'sudah' },
                  { label: 'Belum', value: 'belum' },
                ]}
              />
            </InputWrapperCustom>
          </Box>

          <Box mb='2rem'>
            <InputWrapperCustom
              stateLabel="Pelunasan"
              stateWithAsterisk={false}
              stateError=''
              stateDescription=''
            >
              <SegmentedControl
                fullWidth
                value={data.isLunas}
                onChange={(val) => setData(d => ({ ...d, isLunas: val }))}
                data={[
                  { label: 'Semua', value: utils.flagAll },
                  { label: 'Lunas', value: '1' },
                  { label: 'Belum Lunas', value: '0' },
                ]}
              />
            </InputWrapperCustom>
          </Box>

          <Group position="apart" noWrap spacing='xs' my='xl'>
            <Button
              fullWidth
              variant="default"
              color='gray'
              onClick={handleReset}
            >
              Reset
            </Button>

            <Button
              fullWidth
              color='teal'
              onClick={handleFilter}
            >
              Filter
            </Button>
          </Group>
        </Box>
      </Drawer>

      <TeknisiSelectorDrawer
        stateShow={data.teknisiSelectorModal}
        fnShow={() => setData(d => ({ ...d, teknisiSelectorModal: false }))}
        fnOnSelect={(object) => {
          setData(d => ({
            ...d,
            teknisi: {
              id: object.id,
              name: object.name,
              subLevel: object.subLevel,
            },
            teknisiSelectorModal: false
          }));
        }}
        stateData={{
          isActive: utils.flagAll,
          gender: utils.flagAll
        }}
      />
    </React.Fragment>
  )
}

export default ProjectNotaFilterBayar;